import { t } from 'ember-intl';

<template>
  <h1 class="sr-only">{{t "page_headings.questions_you_have"}}</h1>
</template>
